import {firestoreHelpers} from '@/config/db.js';
import {db} from '@/config/db.js';

export default {
    namespaced: true,
    state: {
        reservations: [],
        nextReservations: [],
    },
    getters: {},
    mutations: {
        setReservations: function (state, data) {
            state.reservations = data;
        }
    },
    actions: {
        async getReservations({rootState, commit}) {
            let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
            let bookingsRef = db.collection("bookings").where('date', '>', yesterday);
            let bookings = await bookingsRef.get();
            let reservations = [];
            bookings.docs.forEach(function (doc) {
                reservations.push(doc.data());
            });
            commit('setReservations', reservations);
        },
        async create({rootState}, booking) {
			const newBooking = db.collection("bookings").doc();
			const newBookingRef = await newBooking.get();
			booking.id = newBookingRef.id;
			await db.collection('bookings').doc(newBookingRef.id).set(booking);
            var userBooking = {
                date: booking.date,
                fixture: booking.fixture,
                id: booking.id,
                services: booking.services,
                userId: booking.userId,
                bookingTitle: booking.bookingTitle,
                bookingType: booking.bookingType
            }
            await db.collection('users').doc(booking.userId).update("bookings", firestoreHelpers.FieldValue.arrayUnion(userBooking));
            return newBookingRef.id;
        },
        async cancel({rootState, dispatch}, booking) {
            let bookingRef = await db.collection('bookings').where('id', '==', booking.id).get();
            let idBooking = bookingRef.docs[0].id;
            delete booking.canCancel;
            await db.collection('bookings').doc(idBooking).delete();
            await db.collection('users').doc(booking.userId).update("bookings", firestoreHelpers.FieldValue.arrayRemove(booking));
            return idBooking;
        }
    }
}
